<sh-basic-chart class="summary-line-chart" [model]="model"></sh-basic-chart>
<sh-chert-legend [legendData]="legend"></sh-chert-legend>
